var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-conteudo"},[_c(_setup.CartaoDeContaAReceberAvulsa,{attrs:{"dado":_setup.props?.dado}}),_c(_setup.TabelaDeRecebimentos,{attrs:{"dado":_setup.props?.dado},on:{"update:alteraRecebimento":_setup.alteraRecebimento}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }